exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#addTypeActivity.modal-dialog{\n    max-width: 30% !important;\n}\n#btnProductivity .btn-data-table{\n    padding-right: 4px !important;\n}\n#btnProductivity .btn-data-table:hover{\n    color: #fff !important;\n}\n", ""]);

// exports
